const SliderArrow = props => {
  const { classNames, styles, onClick } = props;

  return (
    <div
      className={ classNames }
      style={ {...styles} }
      onClick={ onClick }
    />
  );
};

export default SliderArrow;
